/**
 * Le Bugsnag du moteur, sur le web : `@bugsnag/js`, que `common/utils/initBugsnag.web.js` démarre.
 * Même signature que la version mobile (`bugsnagClient.ts`). En développement, rien ne part.
 */
import Bugsnag from "@bugsnag/js"

import { type TelemetryClient } from "./telemetryClient"

export const bugsnagClient: TelemetryClient = {
    notify(error, report) {
        if (__DEV__) return
        Bugsnag.notify(error, (event) => {
            event.context = report.context
            event.severity = report.severity
            event.addMetadata(report.section, report.metadata)
        })
    },
    leaveBreadcrumb(message, metadata) {
        if (__DEV__) return
        Bugsnag.leaveBreadcrumb(message, metadata, "state")
    },
}
